export default __webpack_public_path__ + "static/og-image-930ae928ceee89642367836cecf2209f.png";